import React from 'react'
import { oneOfType, arrayOf, node, number } from 'prop-types'
import { HeadingLarge, HeadingMedium, HeadingSmall } from '@ycos/primitives'

const COMPONENT_MAPPING = {
  1: HeadingLarge,
  2: HeadingMedium,
  3: HeadingSmall
}

const Heading = ({ level, children }) => {
  const Component = COMPONENT_MAPPING[level] || HeadingSmall
  return <Component>{children}</Component>
}

Heading.propTypes = {
  level: number.isRequired,
  children: oneOfType([arrayOf(node), node]).isRequired
}

export default Heading
